import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-buttons" }

import ButtonIcon from '@/components/widgets/ButtonIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionButtons',
  props: {
  stopCancelPropagation: {
    type: Boolean,
    required: false,
    default: false,
  },
  stopConfirmPropagation: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ['confirm', 'cancel'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const handleConfirm = (event) => {
  if (props.stopConfirmPropagation) {
    event.stopPropagation();
    event.preventDefault();
  }
  emit('confirm');
};

const handleCancel = (event) => {
  if (props.stopCancelPropagation) {
    event.stopPropagation();
    event.preventDefault();
  }
  emit('cancel');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ButtonIcon, {
      icon: "x",
      onClick: handleCancel
    }),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createVNode(ButtonIcon, {
      icon: "check",
      onClick: handleConfirm
    })
  ]))
}
}

})